export type BaselineFallback = { requestedYear: number; reason: 'noData' | 'comparisonYear' };

// Why a card compares from a different year than the one requested, if it does.
export const baselineFallback = (years: number[], requestedYear: number | undefined, usedYear: number): BaselineFallback | undefined => {
    if (requestedYear === undefined || requestedYear === usedYear) {
        return undefined;
    } else {
        return { requestedYear, reason: years.includes(requestedYear) ? 'comparisonYear' : 'noData' };
    }
};
